module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hRAHt"))).then(() => parcelRequire('hEqeo'));